<template>
    <el-card>
        <h1 slot="header" class="clearfix fin-text-blue-800">Create Dashboard</h1>

        <el-form ref="form"
                 :model="createDashboard"
                 :rules="rules"
                 label-width="120px"
                 label-position="top"
        >
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="Dashboard Name" prop="dashboard_name">
                        <el-input class="text-capitalize" type="text" id="dashboard_name" name="dashboard_name"
                                  v-model="createDashboard.dashboard_name"/>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Date Range" prop="dateRange">
                        <date-range-picker
                            name="picker"
                            label="Range Picker"
                            v-model="dateRange"
                        ></date-range-picker>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item label="Teams" prop="team_id">
                        <multiselect
                            v-model="team_id"
                            :options="teams"
                            :multiple="true"
                            placeholder="Select As Many..."
                            :close-on-select="false"
                            :clear-on-select="false"
                            track-by="id"
                            label="name"
                            @input="updateTeams">
                        </multiselect>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="Lead Source" prop="lead_source_id">
                        <el-select class="fin-w-full" name="lead_source_id" id="lead_source_id"
                                   v-model="createDashboard.lead_source_id" clearable filterable>
                            <el-option v-for="source in sources" :value="source.id" :key="source.id"
                                       :label="source.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="Hide Header" prop="header_hidden">
                        <el-select class="fin-w-full" name="header_hidden" id="header_hidden" v-model="createDashboard.header_hidden"
                                   clearable
                                   filterable>
                            <el-option :value="1"
                                       :label="'Yes'">
                            </el-option>
                            <el-option :value="0"
                                       :label="'No'">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="Timezone" prop="timezone">
                        <el-select class="fin-w-full" name="timezone"
                                   id="timezone"
                                   v-model="createDashboard.timezone"
                                   clearable filterable>
                            <el-option v-for="timezone in timezones"
                                       :key="timezone"
                                       :value="timezone"
                                       :label="timezone">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Theme" prop="theme">
                        <el-select class="fin-w-full" name="theme" id="theme" v-model="createDashboard.theme" clearable
                                   filterable>
                            <el-option value="black" label="Black">
                            </el-option>
                            <el-option value="white" label="White">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item label="Select Widgets" prop="selected_widgets">
                        <multiselect
                            v-model="createDashboard.selected_widgets"
                            :options="optionsWidgets"
                            :multiple="true"
                            placeholder="Select As Many..."
                            :close-on-select="false"
                            :clear-on-select="false"
                            :preserve-search="true"
                            track-by="id"
                            label="name">
                        </multiselect>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="Select Dashboard View" prop="dashboard_view">
                        <el-select class="fin-w-full" name="dashboard_view" id="dashboard_view"
                                   v-model="createDashboard.dashboard_view" clearable filterable>
                            <el-option value="charts" label="Charts"></el-option>
                            <el-option value="totals" label="Totals"></el-option>
                            <el-option value="carousels" label="Carousels"></el-option>
                            <el-option value="settlements" label="Settlements"></el-option>
                            <el-option value="broker-breakdowns" label="Broker Breakdown"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item label="Dashboard Url" prop="url">
                        <el-input id="url" name="url" v-model="createDashboard.url"
                                  readonly>

                            <template slot="append">
                                <el-button type="primary" id="generate" @click="generateUrl">Generate</el-button>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div class="fin-flex fin-items-stretch fin-justify-end fin-mt-4 fin-w-full">
            <el-button type="success" class="fin-justify-self-end" @click="addDashboard" :loading="loading">
                Save
            </el-button>
        </div>
    </el-card>
</template>

<script>
import Multiselect from "vue-multiselect"
import DateRangePicker from "../../../ambition/components/form-elements/DateRangePicker"

export default {
    name: 'DashboardCreate',
    props: [
        'token',
        'tenantId',
        'dashboard',
        'teams',
        'timezones',
        'sources',
        'widgets',
        'url',
        'tenantName'
    ],
    components: {
        Multiselect,
        "date-range-picker": DateRangePicker,
    },
    data() {
        return {
            dashboardData: [],
            optionsWidgets: [],
            dateRange: {
                startDate: this.$moment().startOf("month"),
                endDate: this.$moment().endOf("month"),
            },
            tenant_name: '',
            broker_id: [],
            team_id: [],
            createDashboard: {
                tenant_id: '',
                start_date: '',
                end_date: '',
                team_id: [],
                lead_source_id: '',
                timezone: '',
                theme: '',
                selected_widgets: [],
                url: '',
                dashboard_name: '',
                dashboard_view: ''
            },
            rules: {
                dashboard_name: [{required: true, message: "Dashboard Name is required"}],
                dashboard_view: [{required: true, message: "Dashboard View is required"}],
                selected_widgets: [{required: true, message: "Select Widgets is required"}],
                url: [{required: true, message: "Url is required"}],
                theme: [{required: true, message: "Theme is required"}],
                timezone: [{required: true, message: "Timezone is required"}],
                header_hidden: [{required: true, message: "Header hidden is required"}],
            },
            loading: false
        }
    },
    mounted() {
    },
    computed: {},
    created() {
        this.createDashboard.tenant_id = this.tenantId
        this.tenant_name = this.tenantName
        this.optionsWidgets = this.widgets
        this.createDashboard.start_date = this.$moment(this.dateRange.startDate).format("YYYY-MM-DD")
        this.createDashboard.end_date = this.$moment(this.dateRange.endDate).format("YYYY-MM-DD")
    },
    destroyed() {
        Echo.leave(`dashboard.${window.Tenant}.${this.dashboardData.id}`)
    },
    methods: {
        addDashboard() {
            this.$refs.form.validate(async (valid, errors) => {
                if (valid) {
                    this.loading = true

                    axios.post("/admin/settings/dashboard/store", this.createDashboard)
                        .then((res) => {
                            this.dashboardData = res.data
                            swal({
                                title: "Success!",
                                type: "success",
                                text: "Dashboard Created",
                            })
                            this.$router.push({path: '/admin/settings/dashboard/index'})
                            this.$router.go()

                            this.loading = false
                        }).catch(error => {
                        console.log('addDashboard error ', error)
                        this.loading = false
                    })
                }
            })
        },
        generateUrl() {
            this.createDashboard.url = this.url
        },
        updateBrokers(brokers) {
            let b = []
            brokers && brokers.length ? brokers.map(broker => b.push(broker.id)) : b
            return this.createDashboard.broker_id = b
        },
        updateTeams(teams) {
            let t = []
            teams && teams.length ? teams.map(team => t.push(team.id)) : t
            return this.createDashboard.team_id = t
        },
    },
    watch: {
        dateRange: {
            handler(newVal, oldVal) {
                let startDate = _.get(newVal, 'startDate')
                let endDate = _.get(newVal, 'endDate')
                this.createDashboard.start_date = this.$moment(startDate).format("YYYY-MM-DD")
                this.createDashboard.end_date = this.$moment(endDate).format("YYYY-MM-DD")
            },
            deep: true,
            immediate: true
        },
    }
}
</script>
